import React from 'react';
import { Button } from '@mui/material';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

const SignUpOptions = ({ loading, onSignUpWithEmail, onSignUpWithGoogle, onBackToSignIn }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
    <Button
      className="auth-oauth-button"
      fullWidth
      variant="outlined"
      onClick={onSignUpWithGoogle}
      disabled={loading}
      startIcon={
        <img src="/svgs/googleLogo.svg" alt="Google" style={{ width: 18, height: 18 }} />
      }
    >
      Sign up with Google
    </Button>
    <div className="divider">
      <span className="divider-text">or</span>
    </div>
    <Button
      fullWidth
      variant="outlined"
      color="inherit"
      startIcon={<AlternateEmailIcon style={{ fontSize: 18 }} />}
      onClick={onSignUpWithEmail}
      style={{ borderRadius: 8, height: 42, textTransform: 'none', fontWeight: 500 }}
    >
      Sign Up with Email
    </Button>
    <div className="auth-bottom-link" style={{ marginTop: 8 }}>
      Already have an account?{' '}
      <a href="/" onClick={(e) => { e.preventDefault(); onBackToSignIn(); }}>Sign in</a>
    </div>
  </div>
);

export default SignUpOptions;
